import React from 'react';
import styled from 'styled-components';

const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const Label = styled.span`
  color: #FFFFFF;
  font-weight: bold;
  line-height: 1.3;
  font-size: 2vw;
  display: block;
  color: #B9C2C9;
`;

const Value = styled.span`
  font-size: 6vw;
  line-height: 1.1;
  font-weight: 800;
  color: #FFFFFF;
  display: inline-block;
  white-space: nowrap;
`;

const CphStat = ({ label, value, styles = {} }) => {
  return (
    <StatWrapper style={styles.wrapper}>
      <Label style={styles.label}>{label}</Label>
      <Value style={styles.value}>{value}</Value>
    </StatWrapper>
  );
};

export default CphStat;